import {
  createCancellableRetryRunner,
  SYNC_RETRY_DELAY_MS,
  SYNC_MAX_RETRIES
} from '../../utils/cancellableRetry';

export async function drainPendingSyncOnce(limit = 25) {
  const { drainPendingSync } = await import('../../infrastructure/storage/syncDrain');
  return drainPendingSync({ limit });
}

export function runElectronOnlineSyncWithRetry({
  retryRunner,
  maxRetries = SYNC_MAX_RETRIES,
  delayMs = SYNC_RETRY_DELAY_MS,
  limit = 40
}) {
  const attemptSync = async (retryCount = 0) => {
    try {
      const result = await drainPendingSyncOnce(limit);
      const ok = result?.outbox?.failed === 0 || (result?.outbox?.done ?? 0) > 0;

      if (!ok && retryCount < maxRetries) {
        retryRunner.schedule(() => attemptSync(retryCount + 1), delayMs);
      }
    } catch {
      if (retryCount < maxRetries) {
        retryRunner.schedule(() => attemptSync(retryCount + 1), delayMs);
      }
    }
  };

  void attemptSync();
}

export function createElectronSyncRetryRunner() {
  return createCancellableRetryRunner();
}

export { SYNC_RETRY_DELAY_MS, SYNC_MAX_RETRIES };
